import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import UnlockFilledSvg from "@ant-design/icons-svg/es/asn/UnlockFilled";
import AntdIcon from "../components/AntdIcon";
var UnlockFilled = function UnlockFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UnlockFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  UnlockFilled.displayName = 'UnlockFilled';
}
export default /*#__PURE__*/React.forwardRef(UnlockFilled);